import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useLocation, useNavigate } from "react-router-dom";
import BasketComp from "../../components/basket-comp/BasketComp";
import Footer from "../../components/footer/Footer";
import MahutiHeader from "../../components/mahuti-header/MahutiHeader";
import { MahutiStepper } from "../../components/mahuti-stepper/MahutiStepper";
import OrderSummary from "../../components/order-summary/OrderSummary";
import ProductDetails from "../../components/product-details/ProductDetails";
import StepperBtns from "../../components/stepper-btns/StepperBtns";
import { setCurrentStep, setFlowType, setSteps } from "../../store/MahutiReducer";
import { ELEMENT_LINK, FLOW_TYPE, PREFIX_PATH, scrollToSection } from "../../utils/GlobalParams";
import { myStepsActivity, myStepsActivityMOBILE } from "../../utils/stepperUtils";
import LandingColumnActivity from "../landing-column-activity/LandingColumnActivity";
import './LandingProduct.css'
import MahutiModal from "../../components/mahuti-modal/MahutiModal";
import { isMobile } from "react-device-detect";
import { checkCartItems } from "../../utils/orderUtils";

export default function LandingProduct(props) {
    const store = useSelector(state => state.reducer);
    const dispatch = useDispatch()
    const [videoOpen, setVideoOpen] = useState(false)
    const selectedActivity = store.selectedActivity;
    const underAgeNum = store.visitors && store.visitors?.underAge ? store.visitors?.underAge : 0;
    const adultNum = store.visitors && store.visitors?.adults ? store.visitors?.adults : 0;
    const sumPrice = (selectedActivity?.price?.underAge ?? 0) * underAgeNum + (selectedActivity?.price?.adults ?? 0) * adultNum
    let summaryCompDisplay = () => store.currentStep === myStepsActivity.length - 1 ? <BasketComp /> : <OrderSummary orderPayment={sumPrice} />
    const location = useLocation();
    const navigate = useNavigate();
    const activity_checkout = store.flowType === 'ACTIVITY_FLOW' && store.currentStep === 2;
    const refMount = useRef(true);
    let steps = isMobile ? myStepsActivityMOBILE : myStepsActivity;
    let lpPrefix = store.lpName ? '/' + store.lpName : '';


    useEffect(() => {
        if (refMount.current) {
            refMount.current = false;
            checkCartItems(store, dispatch, navigate, location)
            store.createMode && dispatch(setFlowType(FLOW_TYPE.ACTIVITY_FLOW))
            store.steps?.length !== 3 && store.createMode && dispatch(setSteps(steps))
            checkSteps()

            if (!location.hash || location.hash === '#productDetailsDisplay') {
                scrollToSection(ELEMENT_LINK[location.hash])
            }
            else {
                scrollToSection('sellingflow_view')
            }
        }
    }, [])

    useEffect(() => {
        checkSteps()
        summaryCompDisplay = () => store.currentStep === myStepsActivity.length - 1 ? <BasketComp /> : <OrderSummary orderPayment={sumPrice} />
    }, [store.currentStep])

    const sendMeHome = () => {
        navigate(`${PREFIX_PATH}${lpPrefix}`)
    }

    const checkSteps = () => {
        if(store.currentStep === 2 && store.createMode && !store.refresh){
            // store.selectedActivities?.length === 0 || 
            if( !store.selectedActivity || 
                !store.activityDate || 
                !store.selectedActivity.visitors ||
                !store.selectedActivity.timing){
                    console.log('activity step 2 test is falsy!!')
                    dispatch(setCurrentStep(store.currentStep - 1))
            }
        }else if(store.currentStep === 1){
            if(!store.selectedActivity || 
                !store.activityDate){
                    console.log('activity step 1 test is falsy!!')
                    dispatch(setCurrentStep(store.currentStep - 1))
            }
        }else{
            //console.log('test ok') 
        }
    }

    useEffect(() => {
        const handleEscape = (event) => {
            if (videoOpen && event.key === 'Escape') {
                setVideoOpen(false);
            }
        };
    
        if (videoOpen) {
            document.addEventListener('keydown', handleEscape);
        }
    
        return () => {
            document.removeEventListener('keydown', handleEscape);
        };
    }, [videoOpen]);

    return <div className="LandingProduct">
         
        <header className="main-header">
            <MahutiHeader contrastTogglerRef={props.contrastTogglerRef} landingPageParams={props.landingPageParams} />
        </header>
        <div id="productDetailsDisplay_view"></div>
        {store.currentStep === 0 && (
            <>
            <div className="sr-only" role="note">
                {selectedActivity?.Title && `סרטון הסבר על ${selectedActivity.Title}. לחצו על התמונה לצפייה בסרטון.`}
            </div>
            <div 
                className={`d-flex justify-content-center align-items-center ${selectedActivity?.videoURL && 'pointer'}`} 
                onClick={() => selectedActivity?.videoURL && setVideoOpen(true) }
                onKeyDown={(e) => {
                    if (e.key === 'Enter' || e.key === ' ') {
                        e.preventDefault();
                        selectedActivity?.videoURL && setVideoOpen(true);
                    }
                }}
                tabIndex={selectedActivity?.videoURL ? "0" : "-1"}
                role={selectedActivity?.videoURL ? "button" : "presentation"}
                aria-label={selectedActivity?.videoURL ? `פתח סרטון על ${selectedActivity?.Title}` : undefined}
            >
                <div className="cover-img" id='productDetailsDisplay' style={{backgroundImage: `url(${selectedActivity?.heroImage})`}}></div>
                <div className="big_video_icon position-absolute"></div>                                  
            </div></>)}

        {videoOpen && store.currentStep === 0 && 
            <MahutiModal 
                closeModalWhenClickingBg={true} 
                setModalOpen={setVideoOpen}
                role="dialog"
                aria-modal="true"
                aria-labelledby="video-modal-title"
            >
                <div className="video-modal-content">
                    <h2 id="video-modal-title" className="visually-hidden">סרטון - {selectedActivity?.Title}</h2>
                    <button 
                        className="close-modal-button"
                        onClick={() => setVideoOpen(false)}
                        aria-label="סגור סרטון"
                        autoFocus
                    >
                        ×
                    </button>
                    {selectedActivity?.videoURL && 
                        <iframe 
                            className='video_iframe_ticket' 
                            src={selectedActivity?.videoURL} 
                            width='100%' 
                            height='100%' 
                            title={`סרטון - ${selectedActivity?.Title}`}
                            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture; fullscreen"
                            allowFullScreen={true}
                        />
                    }
                </div>
            </MahutiModal>
        }

        {store.currentStep === 0 && <div className="section row bg-body gx-0" >
            <div className="col-lg-3 col-12">
                <button className="btn-primary" 
                    onClick={() => { scrollToSection(ELEMENT_LINK["#sellingflow"])}}
                    aria-label={props.landingPageParams?.purchase_button_title__c || 'לרכישת כרטיסים'}
                >
                    {props.landingPageParams?.purchase_button_title__c || 'לרכישת כרטיסים'}
                </button>
            </div>
            <div className="col-lg-4 col-12">
                <ProductDetails {...selectedActivity} />
            </div>
            <div className="col-1 d-lg-block d-none"></div>
            {(selectedActivity?.disclaimer && selectedActivity.disclaimer.length > 0 && selectedActivity.disclaimer[0]) ? (
                <div className={`col-12 col-lg-4 p-2 d-flex ${isMobile ? 'justify-content-start' : 'justify-content-end'}`}>
                    <ul className="text-start product_details_list alef ps-4 pe-5" role="list">
                        {selectedActivity?.disclaimer?.map((item, index) => 
                            item.Name && <li key={item.Id}> {item.Name}</li>
                        )}
                    </ul>
                </div>
            ) : null}
        </div>}

        <div className={`section-stepper m-lg-3 m-0 py-lg-3 py-0 relative ${store.currentStep === 0 ? '' : 'top_spred'}`} id='sellingflow'>
            <div id="sellingflow_view" style={{ position: 'absolute', top: '-80px', left: 0 }}></div>
            <div className="container bg-body gx-0">
                <div className="MahutiStepperWrapper d-flex justify-content-center p-2">
                    {isMobile ? <MahutiStepper steps={myStepsActivityMOBILE} /> : <MahutiStepper steps={myStepsActivity} />}
                </div>
               
                <div className="row gx-0 justify-content-center mob_gray_back">
                    {store.columnMessage?.info && (activity_checkout) && !store.columnMessage?.alert &&
                        <div className="alert alert-success alef rounded-0 boot_msg" role="alert">
                            <span className="">{store.columnMessage?.info}</span>
                        </div>}
                    {store.columnMessage?.alert && (activity_checkout) &&
                    <div className="alert_warning_back boot_msg" role="alert">
                        <span className="alert_warning">{store.columnMessage.alert}</span>
                    </div>}

                    <div className="col-lg-7 col-12">
                        <LandingColumnActivity />
                    </div>
                    
                    <div id='orderSummaryWrapper' className="col-12 col-lg-5">
                        <div className="order_summery_box pe-lg-5 ps-lg-5 pb-lg-5">
                            {summaryCompDisplay()}
                        </div>
                    </div>
                </div>

                {store.currentStep < myStepsActivity.length - 1 &&
                <div className="row gx-0 gx-lg-4">
                    <div className="col-lg-7 col-12 d-flex justify-content-end pb-lg-5 pb-0">
                        <StepperBtns steps={myStepsActivity} />
                    </div>
                </div>}
            </div>
        </div>
        <Footer landingPageParams={props.landingPageParams} />
    </div>
}